import { FC } from 'react'

import styled from 'styled-components'

import Exclamation from 'src/Assets/Svg/referAndEarn/exclamation.svg?react'
import { landingPageUrl } from 'src/Constants/links'
import { variables } from 'src/Styled/variables'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'

export const ReferralLinkNotExistBlock = styled.div`
  z-index: 300;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin-top: 60px;
  background-color: ${({ theme }) => theme.color.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
`

export const ReferralLinkNotExistHead = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

export const ReferralLinkNotExistText = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

export const ReferralLinkNotExistButton = styled.div`
  width: 200px;
  align-self: center;
  display: flex;
  justify-content: center;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

const StyledButton = styled(PrimaryButton)`
  font-weight: 600;
`

const ReferralLinkNotExist: FC = () => (
  <ReferralLinkNotExistBlock>
    <Exclamation />
    <TextWrapper>
      <ReferralLinkNotExistHead>
        This referral link doesn’t exist
      </ReferralLinkNotExistHead>

      <ReferralLinkNotExistText>
        Check if your invitation link is correct and try again
      </ReferralLinkNotExistText>
    </TextWrapper>

    <ReferralLinkNotExistButton>
      <a href={landingPageUrl} target='_blank' rel='noopener noreferrer'>
        <StyledButton>Go to SoundCampaign</StyledButton>
      </a>
    </ReferralLinkNotExistButton>
  </ReferralLinkNotExistBlock>
)
export default ReferralLinkNotExist
